import { render, staticRenderFns } from "./elButton.vue?vue&type=template&id=2f3b6eee&scoped=true&"
import script from "./elButton.vue?vue&type=script&lang=js&"
export * from "./elButton.vue?vue&type=script&lang=js&"
import style0 from "./elButton.vue?vue&type=style&index=0&id=2f3b6eee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3b6eee",
  null
  
)

export default component.exports